import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CommentableType } from '@/app/spraypaint/Comment';
import { FaMessage } from 'react-icons/fa6';
import { useCommentModal } from '@common/components/comments/hooks/useCommentModal';
import { Button } from '../buttons';
import { CommentFormValue, CommentList } from './CommentList';
import { useAddComment } from './hooks/useAddComment';
import { useGetComments } from './hooks/useGetComments';
import { AbsoluteShowNumber } from '../fragments/AbsoluteShowNumber';

type Props = {
  commentableId?: string;
  commentableType: CommentableType;
};

export const CommentWidget = ({ commentableId, commentableType }: Props) => {
  const { onClick, CommentsModal, commentsCount } = useCommentModal({
    commentableType,
    commentableId,
    title: 'Commentaires',
  });

  return (
    <div className="fixed z-[100] top-[350px] right-[20px] flex">
      <AbsoluteShowNumber
        itemCount={commentsCount}
        className="bg-color-pone-orange"
      />
      <CommentsModal />
      <Button
        custom
        onClick={onClick}
        className="bg-white h-[50px] w-[50px] rounded-full border-[1px] border-color-medium-grey bg-color-pone-dark flex justify-center items-center"
      >
        <div className="text-xxl">
          <FaMessage color="white" className="h-[22px]" />
        </div>
      </Button>
    </div>
  );
};
